import { Grid } from '@mui/material';
import { FormControl } from '../../../../../ui/components/pure/form-control/form-control.component';
import { Dropdown } from '../../../../../ui/components/pure/dropdown/dropdown.component';
import { TextField } from '../../../../../ui/components/pure/text-field/text-field.component';
import { CourierFormModal } from '../../../components/courier-form-modal.component';
import { fullWidthStyle, rowGroupStyle } from '../../../components/courier-form.styles';
import { EditApprovalActionProps, useEditApprovalAction } from './edit-approval-action.hook';

/**
 * Approves or rejects a courier. Kept apart from the edit modal so a detail change cannot carry a
 * lifecycle change with it.
 */
export function EditApprovalModal(props: EditApprovalActionProps) {
  const { state, handlers, control, handleSubmit, formConfig, approvalOptions } = useEditApprovalAction(props);

  return (
    <CourierFormModal
      title={`Edit approval for ${props.courier.displayName || 'courier'}`}
      saving={state.saving}
      error={state.error}
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      <Grid container spacing={2} style={rowGroupStyle}>
        <Grid size={12}>
          <FormControl
            control={control}
            name={formConfig.approvalStatus.name}
            required={formConfig.approvalStatus.required}
            ComponentProps={{
              dropdownVariant: 'floating' as const,
              placeholder: formConfig.approvalStatus.label,
              menuItems: approvalOptions,
              textFieldDesktopWidth: '100%',
              fullWidth: true,
              style: fullWidthStyle
            }}
            Component={Dropdown}
          />
        </Grid>
        <Grid size={12}>
          {/* Optional. Without it the note records only who decided and when. */}
          <FormControl
            control={control}
            name={formConfig.reason.name}
            required={formConfig.reason.required}
            rules={{ validate: formConfig.reason.validate }}
            ComponentProps={{
              textFieldVariant: 'floating' as const,
              placeholder: `${formConfig.reason.label} (optional)`,
              multiline: true,
              minRows: 3,
              fullWidth: true,
              style: fullWidthStyle
            }}
            Component={TextField}
          />
        </Grid>
      </Grid>
    </CourierFormModal>
  );
}
